import { useSelector } from 'react-redux';
import { useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import getBUFromLocalStorage from 'EmailComponents/utils/getBUFromLocalStorage';
import { InsightContextProviderBase } from 'messaging-publishing-lib/Insights/components/InsightContextProviderBase';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { getShouldUseBusinessUnitContext } from 'messaging-publishing-lib/Insights/utils';
import { hasAccessToBusinessUnit as getHasAccessToBusinessUnit } from 'email-management-lib/refactor/selectors/user';
import { getIsUngatedForInsightsGARelease } from 'email-management-lib/refactor/selectors/user';
import { jsx as _jsx } from "react/jsx-runtime";
function InsightContextProvider(props) {
  var _getQuickFilterValue, _getQuickFilterValue2;
  const {
    getQuickFilterValue
  } = useListingLibQuickFilters();
  const hasAccessToBusinessUnit = useSelector(getHasAccessToBusinessUnit);
  const businessUnitId = getBUFromLocalStorage();
  const shouldUseBusinessUnitContext = hasAccessToBusinessUnit && getShouldUseBusinessUnitContext(businessUnitId);
  const hasCampaign = (_getQuickFilterValue = getQuickFilterValue(PROPERTIES.CAMPAIGN_GUID)) === null || _getQuickFilterValue === void 0 ? void 0 : _getQuickFilterValue.length;
  const isAutomatedEmail = (_getQuickFilterValue2 = getQuickFilterValue(PROPERTIES.EMAIL_TYPE)) === null || _getQuickFilterValue2 === void 0 ? void 0 : _getQuickFilterValue2.some(type => type.startsWith('AUTOMATED_'));
  const isUngatedForInsightsGARelease = useSelector(getIsUngatedForInsightsGARelease);
  return /*#__PURE__*/_jsx(InsightContextProviderBase, Object.assign({
    shouldUseBusinessUnitContext: shouldUseBusinessUnitContext,
    hasCampaign: hasCampaign,
    isAutomatedEmail: isAutomatedEmail,
    isUngatedForGARelease: isUngatedForInsightsGARelease
  }, props));
}
export default InsightContextProvider;